import { Link } from "@mui/material";
import Image from "@Components/Image";
import { CMSImageType } from "@Types/Contentful";
import { convertToValidHTMLId } from "@Utils/stringUtils";
import classes from "./CommonTopMenu.module.scss";

export type faqItemType = {
  title: string;
  icon: CMSImageType;
};

type Props = {
  item: faqItemType;
};

export const CommonTopMenuItem = ({ item }: Props) => {
  const handleTabClick = (tabId: string) => {
    //Find header block
    const headElement = document.getElementById("site-header");

    //Header Block Height
    const headerHeight = headElement?.clientHeight ?? 0;

    //Find Element to Scroll
    const scrollToEl: any = document.querySelector(`#${tabId}`);

    //Scroll Event - scroll element below the header component
    const topOfElement =
      window.pageYOffset +
      scrollToEl?.getBoundingClientRect()?.top -
      headerHeight;
    window.scroll({ top: topOfElement, behavior: "smooth" });
  };

  return (
    <li
      className={classes["menu-item"]}
      onClick={() => handleTabClick(convertToValidHTMLId(item?.title))}
    >
      <Link className={classes["menu-link"]}>
        <div className={classes["icon"]}>
          <Image src={`${item?.icon?.url}?w=40&h=40`} width={40} height={40} />
        </div>
        {item?.title}
      </Link>
    </li>
  );
};
